<button type="button" class="mm-search-trigger" (click)="search.open()"
        [attr.aria-label]="lang.isArabic ? 'بحث' : 'Search'" title="{{ lang.isArabic ? 'بحث' : 'Search' }}">
  <i class="fa fa-search" aria-hidden="true"></i>
</button>
